import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { ajaxconfig } from "../ajaxconfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import cookie from "universal-cookie";

const TestCompletion = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const cookies = new cookie();
    const [testDetails, setTestDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submissionType, setSubmissionType] = useState('mixed'); // 'mcq', 'essay', 'mixed'

    // Get test data from location state or fetch it
    useEffect(() => {
        const fetchTestDetails = async () => {
            try {
                setLoading(true);
                // Simulate API call to get test details
                // In real implementation, you would get this from your backend
                const testData = location.state?.testData || {
                    testName: "Mathematics Assessment",
                    testId: location.state?.testId || "TEST_001",
                    submissionTime: new Date().toISOString(),
                    hasEssayQuestions: location.state?.hasEssayQuestions || true,
                    hasMcqQuestions: location.state?.hasMcqQuestions || true,
                    totalQuestions: location.state?.totalQuestions || 25,
                    completedQuestions: location.state?.completedQuestions || 25
                };

                setTestDetails(testData);

                // Determine submission type for appropriate messaging
                if (testData.hasEssayQuestions && testData.hasMcqQuestions) {
                    setSubmissionType('mixed');
                } else if (testData.hasEssayQuestions) {
                    setSubmissionType('essay');
                } else {
                    setSubmissionType('mcq');
                }

                // Simulate processing delay
                setTimeout(() => {
                    setLoading(false);
                }, 2000);

            } catch (error) {
                console.error("Error fetching test details:", error);
                toast.error("Failed to load test details");
                setLoading(false);
            }
        };

        fetchTestDetails();
    }, [location]);

    const handleReturnToDashboard = () => {
        navigate('/participate/dashboard');
    };

    const getCompletionMessage = () => {
        switch (submissionType) {
            case 'mcq':
                return {
                    title: "Test Successfully Graded!",
                    subtitle: "Your multiple-choice questions have been automatically graded by the system.",
                    icon: "✅",
                    color: "green"
                };
            case 'essay':
                return {
                    title: "Essay Submitted Successfully!",
                    subtitle: "Your essay answers have been submitted and are pending instructor evaluation.",
                    icon: "📝",
                    color: "blue"
                };
            case 'mixed':
            default:
                return {
                    title: "Test Submitted Successfully!",
                    subtitle: "Your multiple-choice questions have been graded automatically, while essay questions are pending instructor evaluation.",
                    icon: "📊",
                    color: "purple"
                };
        }
    };

    const getStatusDetails = () => {
        const baseDetails = [
            {
                icon: "⏰",
                title: "Submission Time",
                value: testDetails ? new Date(testDetails.submissionTime).toLocaleString() : new Date().toLocaleString(),
                color: "gray"
            },
            {
                icon: "📋",
                title: "Total Questions",
                value: testDetails?.totalQuestions || "N/A",
                color: "blue"
            }
        ];

        if (submissionType === 'mcq' || submissionType === 'mixed') {
            baseDetails.push({
                icon: "⚡",
                title: "Auto-graded Questions",
                value: "Completed",
                color: "green"
            });
        }

        if (submissionType === 'essay' || submissionType === 'mixed') {
            baseDetails.push({
                icon: "👨‍🏫",
                title: "Pending Evaluation",
                value: "Instructor Review",
                color: "yellow"
            });
        }

        return baseDetails;
    };

    const message = getCompletionMessage();
    const statusDetails = getStatusDetails();

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Processing Your Submission</h3>
                        <p className="text-gray-600">Please wait while we finalize your test results...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-8">
                    <div className="flex justify-center mb-4">
                        <div className={`w-20 h-20 rounded-full bg-${message.color}-100 flex items-center justify-center text-3xl`}>
                            {message.icon}
                        </div>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-2">
                        {message.title}
                    </h1>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        {message.subtitle}
                    </p>
                </div>

                {/* Test Details Card */}
                {/* <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-8">
                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-4">
                        <h2 className="text-xl font-bold text-white flex items-center justify-center">
                            <span className="mr-2">📄</span>
                            Test Summary
                        </h2>
                    </div>
                    <div className="p-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {statusDetails.map((detail, index) => (
                                <div key={index} className="flex items-center p-4 bg-gray-50 rounded-xl border border-gray-200">
                                    <div className={`w-12 h-12 rounded-xl bg-${detail.color}-100 flex items-center justify-center text-xl mr-4`}>
                                        {detail.icon}
                                    </div>
                                    <div>
                                        <p className="text-sm font-medium text-gray-600">{detail.title}</p>
                                        <p className="text-lg font-semibold text-gray-900">{detail.value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}

                {/* Information Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    {/* Auto-grading Info */}
                    {(submissionType === 'mcq' || submissionType === 'mixed') && (
                        <div className="bg-green-50 border border-green-200 rounded-2xl p-6">
                            <div className="flex items-start mb-4">
                                <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center text-green-600 mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-green-800 mb-2">Automatically Graded</h3>
                                    <p className="text-green-700 text-sm">
                                        Your multiple-choice questions have been instantly graded by the system. 
                                        Results are available immediately.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Pending Evaluation Info */}
                    {(submissionType === 'essay' || submissionType === 'mixed') && (
                        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6">
                            <div className="flex items-start mb-4">
                                <div className="w-10 h-10 bg-yellow-100 rounded-xl flex items-center justify-center text-yellow-600 mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-yellow-800 mb-2">Pending Evaluation</h3>
                                    <p className="text-yellow-700 text-sm">
                                        Your essay questions are being reviewed by the instructor. 
                                        You'll be notified when evaluation is complete.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Next Steps Card */}
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-8">
                    <div className="bg-gradient-to-r from-gray-600 to-gray-700 px-6 py-4">
                        <h2 className="text-xl font-bold text-white flex items-center justify-center">
                            <span className="mr-2">🎯</span>
                            Next Steps
                        </h2>
                    </div>
                    <div className="p-6">
                        <div className="space-y-4">
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mr-4 mt-1 flex-shrink-0">
                                    <span className="text-sm font-bold">1</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900 mb-1">Check Your Dashboard</h4>
                                    <p className="text-gray-600 text-sm">
                                        Return to your dashboard to track the status of all your tests and view available results.
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-600 mr-4 mt-1 flex-shrink-0">
                                    <span className="text-sm font-bold">2</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900 mb-1">Review Results</h4>
                                    <p className="text-gray-600 text-sm">
                                        Once all components are graded, you'll be able to see your detailed score breakdown and feedback.
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 mr-4 mt-1 flex-shrink-0">
                                    <span className="text-sm font-bold">3</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900 mb-1">Get Notified</h4>
                                    <p className="text-gray-600 text-sm">
                                        You'll receive a notification when your instructor completes evaluating essay questions.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="text-center">
                    <button
                        onClick={handleReturnToDashboard}
                        className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-4 px-8 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-xl inline-flex items-center"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        Return to Dashboard
                    </button>
                    
                    <p className="text-gray-500 text-sm mt-4">
                        You can always come back later to check your results
                    </p>
                </div>

                {/* Additional Help */}
                <div className="text-center mt-8">
                    <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 inline-block">
                        <p className="text-blue-800 text-sm">
                            <strong>Need help?</strong> Contact your instructor if you have questions about your submission.
                        </p>
                    </div>
                </div>
            </div>

            <ToastContainer 
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
                toastClassName="rounded-xl"
            />

            <style jsx>{`
                .bg-green-100 { background-color: #dcfce7; }
                .bg-green-50 { background-color: #f0fdf4; }
                .text-green-600 { color: #16a34a; }
                .text-green-700 { color: #15803d; }
                .text-green-800 { color: #166534; }
                .border-green-200 { border-color: #bbf7d0; }

                .bg-yellow-100 { background-color: #fef9c3; }
                .bg-yellow-50 { background-color: #fefce8; }
                .text-yellow-600 { color: #ca8a04; }
                .text-yellow-700 { color: #a16207; }
                .text-yellow-800 { color: #854d0e; }
                .border-yellow-200 { border-color: #fef08a; }

                .bg-blue-100 { background-color: #dbeafe; }
                .bg-blue-50 { background-color: #eff6ff; }
                .text-blue-600 { color: #2563eb; }
                .text-blue-700 { color: #1d4ed8; }
                .text-blue-800 { color: #1e40af; }
                .border-blue-200 { border-color: #bfdbfe; }

                .bg-purple-100 { background-color: #e9d5ff; }
                .bg-purple-50 { background-color: #faf5ff; }
                .text-purple-600 { color: #9333ea; }
                .text-purple-700 { color: #7e22ce; }
                .text-purple-800 { color: #6b21a8; }
                .border-purple-200 { border-color: #d8b4fe; }
            `}</style>
        </div>
    );
};

export default TestCompletion;